/**!
 * Created by Leonardo Cheslacki on 29/01/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import HelpersController from './HelpersController';

let _this = {};

/**
 *
 */
class HelpersForm extends HelpersController {
    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main) {
        super(props);

        this.props = props;
        this.main = main;

        const {headers, target} = this.props;

        this.state = {
            headers: headers,
            data: null
        };

        this.$FormData = (new FormData());
        this.$objectResponse = {};

        this.setTarget(target);

        _this = this;
    };

    /**
     *
     */
    deleteData = () => {
        this.$FormData = (new FormData());
        this.setStates({data: null});
    };

    /**
     *
     * @param data
     * @param callback
     */
    setToJsonData = (data, callback) => {
        if (this.isObjectIf(data)) {
            this.deleteData();
            this.setStates({data: JSON.stringify(data)}, callback);
        }
    };

    /**
     *
     * @param data
     * @param callback
     */
    setToFormData = (data, callback) => {
        if (this.isArrayIf(data)) {
            this.deleteData();
            this.recursiveSyncMap(data, 0, data.length, (item, next) => {
                let name = this.verifyField(item, 'name');

                name && this.$FormData.append(name, this.verifyField(item, 'value', false, null));
                next(true);
            }, callback);
        }
    };

    /**
     *
     * @param headers
     * @param callback
     */
    setHeaders = (headers, callback = null) => {
        if (this.isObjectIf(headers)) {
            this.setStates({headers: headers}, callback);
        }
    };

    /**
     *
     * @param target
     * @param callback
     */
    setTarget = (target, callback = null) => {
        if (this.isObjectIf(target)) {
            const {method} = target;

            if (this.inArray(['GET', 'PUT', 'POST', 'DELETE'], method)) {
                let headers = method ? {headers: {'X-HTTP-Method-Override': method}} : {};

                this.setStates({target: target, ...headers}, callback);
            }
        }
    };

    /**
     *
     * @returns {string|FormData}
     */
    getData = () => {
        const {type} = this.props;
        return (type === 'json') ? this.getState('data') : this.$FormData;
    };

    /**
     *
     * @returns {string|FormData}
     */
    getContentType = () => {
        const {type} = this.props;
        return ((type === 'json') ? 'application/json' : false);
    };

    /**
     *
     * @param response
     */
    always = (response) => {
        this.deleteData();
        this.inFunction(this.$objectResponse, 'always') && this.$objectResponse.always(response);
    };

    /**
     *
     */
    submit = () => {
        const
            {type} = this.props,
            {target: {method, action}, headers} = this.state;

        this.main.$jQuery.ajaxSetup({headers: headers});

        this.main.$jQuery.ajax({
            method: method,
            url: action,
            data: this.getData(),
            contentType: this.getContentType(),
            processData: false,
            dataType: type,
            beforeSend: ((typeof (this.$objectResponse.beforeSend) === 'function') ? this.$objectResponse.beforeSend : this._void)
        })
            .done(this.inFunction(this.$objectResponse, 'done') ? this.$objectResponse.done : this._void)
            .fail(this.inFunction(this.$objectResponse, 'fail') ? this.$objectResponse.fail : this._void)
            .always(this.inFunction(this.$objectResponse, 'always') ? this.always : this._void);
    };
}

/**
 *
 * @type {{headers: Requireable<object>, name: Requireable<string>, type: Requireable<string>, target: Requireable<object>}}
 */
const propTypes = {
    name: PropTypes.string,
    headers: PropTypes.object,
    target: PropTypes.object,
    type: PropTypes.oneOf(['json', 'xml'])
};

/**
 *
 * @type {{default: {headers: {"X-HTTP-Method-Override": string}, name: string, type: string, target: {method: string, action: string}}}}
 */
const config = {
    default: {
        name: 'form',
        headers: {'X-HTTP-Method-Override': 'GET'},
        target: {method: 'GET', action: `${window.protocol}//${window.host}`},
        type: 'json'
    }
};

/**
 *
 * @param _this
 * @returns {function(*): function(): HelpersForm}
 */
export default (_this) => (props) => {
    const defaultProps = {...config.default, ...props};
    PropTypes.checkPropTypes(propTypes, defaultProps, 'prop', 'HelpersForm');
    return () => (new HelpersForm(defaultProps, _this));
};